import request from '@/utils/request'

// 列表
export function companyList(data) {
  return request({
    url: 'admin/sys/camera/companyList',
    method: 'post',
    data
  })
}
// 列表
export function listPage(data) {
  return request({
    url: 'admin/sys/camera/list',
    method: 'post',
    data
  })
}
// 初始化下拉数据
export function init() {
  return request({
    url: 'admin/sys/camera/init',
    method: 'post'
  })
}
// 删除
export function del(data) {
  return request({
    url: 'admin/sys/camera/delete',
    method: 'post',
    data
  })
}

// 新增或修改
export function saveOrUpdate(data) {
  return request({
    url: 'admin/sys/camera/saveOrUpdate',
    method: 'post',
    data
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/sys/camera/info/' + id,
    method: 'get'
  })
}

// 详情
export function getSecondTypeList(id) {
  return request({
    url: 'admin/sys/camera/getSecondTypeList/' + id,
    method: 'get'
  })
}
